import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell, ConfirmationView } from "@/pages/ForgotPassword";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, LifeBuoy } from "lucide-react";
import api, { readError } from "@/lib/api";

export default function Recovery() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/recovery/request", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(readError(err, "Could not submit the request."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Lost 2FA access">
      {sent ? (
        <ConfirmationView
          testid="recovery-confirmation"
          title="If you're authorized, check your inbox"
          body="If the email you provided is the authorized recovery address, a 15-minute recovery link has been sent. To prevent enumeration we don't confirm which email is allowed."
        />
      ) : (
        <form onSubmit={submit} className="space-y-6" data-testid="recovery-form">
          <p className="text-sm text-muted-foreground leading-relaxed">
            For security, only one pre-configured email address can request 2FA recovery.
            If your authenticator is lost, submit that address below.
          </p>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              required
              autoFocus
              value={email}
              disabled={busy}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="h-11 bg-card"
              data-testid="recovery-email-input"
            />
          </div>
          {error && (
            <div className="text-sm rounded-lg border border-destructive/40 bg-destructive/10 px-3 py-2 text-destructive">
              {error}
            </div>
          )}
          <Button type="submit" disabled={busy} data-testid="recovery-submit-btn" className="w-full h-11 shadow-interactive">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <LifeBuoy className="h-4 w-4" strokeWidth={1.5} />}
            {busy ? "Sending…" : "Send recovery link"}
          </Button>
        </form>
      )}
      <div className="mt-6 text-center text-xs text-muted-foreground">
        <Link to="/admin/login" className="hover:text-primary transition-colors">
          ← Back to login
        </Link>
      </div>
    </AuthShell>
  );
}
